<template>
  <div class="flex justify-center items-center">
    <Carousel
      class="relative w-full"
      :opts="{
        align: 'start',
        loop: true,
      }"
      :plugins="[
        AutoScroll({
          speed: 1,
        }),
      ]"
    >
      <CarouselContent>
        <CarouselItem v-for="(imageUrl, i) in imageUrls" :key="i" class="basis-auto px-6 md:px-14 h-7 lg:h-10">
          <div class="p-0">
            <img :src="imageUrl" :alt="imageUrl" class="h-7 lg:h-10" />
          </div>
        </CarouselItem>
        <!-- we do this to create a seamless loop on higher resolution screens -->
        <CarouselItem v-for="(imageUrl, i) in imageUrls" :key="i" class="basis-auto px-6 md:px-14 h-7 lg:h-10">
          <div class="p-0">
            <img :src="imageUrl" :alt="imageUrl" class="h-7 lg:h-10" />
          </div>
        </CarouselItem>
      </CarouselContent>
    </Carousel>
  </div>
</template>

<script setup lang="ts">
import { Carousel, CarouselContent, CarouselItem } from '@/components/ui/carousel';
import AutoScroll from 'embla-carousel-auto-scroll';
import { computed } from 'vue';

interface Props {
  variant?: 'light' | 'dark';
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'dark',
});

// Local merchant images (dark logos for light backgrounds)
const merchantImages = import.meta.glob('@/assets/images/merchants/*.{svg,png}', { eager: true, import: 'default' });
const darkLogoUrls = Object.values(merchantImages) as string[];

// Local merchant images (light/white logos for dark backgrounds)
const merchantImagesLight = import.meta.glob('@/assets/images/business/merchants/*.{svg,png,webp}', {
  eager: true,
  import: 'default',
});
const lightLogoUrls = Object.values(merchantImagesLight) as string[];

const imageUrls = computed(() => {
  return props.variant === 'light' ? lightLogoUrls : darkLogoUrls;
});
</script>
